import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RestaurantDashboard from './RestaurantDashboard';
import MenuManagement from './MenuManagement';
import './RestaurantApp.css';

function RestaurantApp() {
  return (
    <div className="restaurant-app">
      <Routes>
        <Route path="/" element={<RestaurantDashboard />} />
        <Route path="/menu" element={<MenuManagement />} />
      </Routes>
    </div>
  );
}

export default RestaurantApp;

